/**
 * Enumeración de TypeAttach
 */
 export enum TypeAttach {
  None = 0,
  Required = 1,
  Optional = 2,
  Disabled = 3,
}
